<app-customer-name-disp (targetSelected)="selectTargetOrganization($event)"></app-customer-name-disp>
<app-main-contents *ngIf="organizationCd">
  <app-title [title]="title"></app-title>
  <app-create-customer-form
    *ngIf="organizationCd"
    [organizationCd]="organizationCd"
    (commit)="commit($event)"
  ></app-create-customer-form>
</app-main-contents>
